const _ = require("lodash");
import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  VStack,
  HStack,
  Button,
  useTheme,
} from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import { cqAPI } from "../../lib/Auth";
import { sendEvent } from "../../lib/GA";
import ReactSelect from "react-select";

function IntercomArea({
                        toast,
                        colorMode,
                        uid,
                        isMobile,
                      }) {
  const [adecMessages, setAdecMessages] = useState([]);
  const [adecReplies, setAdecReplies] = useState([]);
  const [intercomMessage, setIntercomMessage] = useState('');
  const theme = useTheme();

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "250px",
      fontWeight:'bold',
      backgroundColor: theme.colors.gray[100],
      borderColor: theme.colors.gray[300],
      boxShadow: theme.shadows.sm,
      "&:hover": {
        borderColor: theme.colors.gray[400],
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: theme.colors.gray[50],
      width: "max-content",
      minWidth: "100%"
    }),
    option: (provided, state) => ({
      ...provided,
      textAlign: "left",
      backgroundColor: state.isSelected
        ? theme.colors.blue[100]
        : theme.colors.gray[50],
      color: theme.colors.lightText,
      "&:hover": {
        backgroundColor: theme.colors.blue[50],
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      // width: "200px",
      justifyContent: "flex-start",
    })
    // Add other style overrides as needed
  };

  const fetchAdecMessages = async () => {
    try {
      const response = await cqAPI.get('/settings/a-dec/messages/predefined');
      if (response.type === 'ok') {
        setAdecMessages(response.data.messages);
        setAdecReplies(response.data.replies);
      } else if (response.type === 'error') {
        return toast({
          title: "Error",
          description: response.msg,
          status: "error",
          duration: 7000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchAdecMessages();
  }, []);

  const sendIntercom = async () => {
    try {
      const body = {
        message: intercomMessage,
        receiver_id: uid,
      }

      sendEvent("message-sent", {
        type: 'intercom',
        direction: "outgoing",
        is_patient: false,
      });

      const response = await cqAPI.post('/a-dec/message', body);
      if (response.type === 'error') {
        return toast({
          title: "Error",
          description: response.msg,
          status: "error",
          duration: 7000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.msg,
        status: "error",
        duration: 7000,
        isClosable: true,
      });
      console.log(error);
    }
  }

  const groupedResponseOptions = [
    {
      label: "Messages",
      options: adecMessages.map((msg, index) => ({
        value: `message-${index}`,
        label: msg,
      })),
    },
    {
      label: "Replies",
      options: adecReplies.map((reply, index) => ({
        value: `reply-${index}`,
        label: reply,
      })),
    },
  ];

  return (
    <>
      <Box
        w="100%"
        className="input-area"
        bg={colorMode === "dark" ? "#212330" : "#FFFFFF"}
        color={colorMode === "light" ? "#000000" : "#ffffff"}
      >
        <Flex direction="column" flex="1" height="90px">
          <VStack spacing={3} align="stretch">
            <HStack>
              <ReactSelect
              placeholder="Select a message"
                styles={customStyles}
                menuPlacement="top"
                options={groupedResponseOptions}
                onChange={(e) => setIntercomMessage(e.label)}
              />
            </HStack>
            <div style={{ width: "100%" }}>
              <Flex direction="column" position="relative">
                <Flex direction="column" w="full" position="relative">
                  {/*<div style={{ position: "absolute", top: "0px", left: "0px" }}>*/}
                  {/*  {intercomMessage ? intercomMessage : "Select your Message or Reply..."}*/}
                  {/*</div>*/}
                  <Flex align="center" className="text-area-button">
                    <Button
                      variant="sendMessage"
                      onClick={sendIntercom}
                      isDisabled={intercomMessage === ""}
                      ml={"auto"}
                    >
                      <ArrowForwardIcon/>
                    </Button>
                  </Flex>
                </Flex>
              </Flex>
            </div>
          </VStack>
        </Flex>
      </Box>
    </>
  );
}

export default IntercomArea;
